import { motion } from "framer-motion";

/**
 * PageHero — hero per le pagine interne
 * mode="cover"   (default): bg-cover, ottimale per foto landscape
 * mode="contain": mostra l'intera foto senza taglio, su sfondo scuro
 */
export default function PageHero({ image, overline, title, subtitle, mode = "cover", bgPosition = "center center" }) {
  const isContain = mode === "contain";

  return (
    <div
      data-testid="page-hero"
      className={`relative flex items-end overflow-hidden ${
        isContain
          ? "min-h-[50vh] md:min-h-[60vh]"
          : "h-[50vh] md:h-[58vh]"
      }`}
      style={isContain ? { backgroundColor: "#1A1917" } : {}}
    >
      {/* Background image */}
      <div
        className={`absolute inset-0 transition-transform duration-[10s] ease-out ${
          isContain ? "" : "scale-105"
        }`}
        style={{
          backgroundImage: `url(${image})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: isContain ? "center center" : bgPosition,
          backgroundSize: isContain ? "contain" : "cover",
          backgroundColor: isContain ? "#1A1917" : "transparent",
        }}
      />

      {/* Gradient overlay */}
      <div
        className="absolute inset-0"
        style={{
          background: isContain
            ? "linear-gradient(to top, rgba(26,25,23,0.85) 0%, rgba(26,25,23,0.3) 40%, transparent 100%)"
            : "linear-gradient(to top, rgba(42,39,38,0.75) 0%, rgba(42,39,38,0.3) 50%, transparent 100%)",
        }}
      />

      {/* Text content */}
      <div className="relative z-10 w-full px-5 md:px-12 pb-10 md:pb-20 max-w-7xl mx-auto">
        {overline && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="font-['Manrope',sans-serif] text-[10px] md:text-xs uppercase tracking-[0.3em] text-[#7B907F] mb-3"
          >
            {overline}
          </motion.p>
        )}
        <motion.h1
          initial={{ opacity: 0, y: 25 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.35 }}
          className="font-['Cormorant_Garamond',serif] text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light text-[#FDFBF7] tracking-tight leading-tight"
        >
          {title}
        </motion.h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.5 }}
            className="font-['Manrope',sans-serif] text-sm md:text-base text-[#FDFBF7]/65 mt-3 max-w-xl leading-relaxed"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </div>
  );
}
